import {AsyncPipe, NgClass} from '@angular/common';
import {Component, inject} from '@angular/core';
import {MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {BreakpointService} from 'src/app/shared/services/breakpoint/breakpoint.service';

@Component({
  selector: 'app-download-dialog',
  imports: [
    AsyncPipe,
    NgClass,
    MatDialogContent,
  ],
  templateUrl: './download-dialog.component.html',
  styleUrl: './download-dialog.component.scss',
})
export class DownloadDialogComponent {
  private breakpointService = inject(BreakpointService);
  deviceSize$ = this.breakpointService.deviceSize$;

  dialogRef = inject<MatDialogRef<DownloadDialogComponent>>(MatDialogRef);

  close() {
    this.dialogRef.close();
  }
}
